module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'widget',
      _vm.hasMargin && 'tab-margin',
      _vm.tabTitles.length === 2 && !_vm.isSlot && _vm.type != 'third-group' && !_vm.isFlexStart && 'tab-padding-160',
      _vm.tabTitles.length === 3 && !_vm.isSlot && _vm.type != 'third-group' && !_vm.isFlexStart && 'tab-padding-40',
      _vm.isSlot && 'flex-expand-layout',
      _vm.type == 'third-group' && 'thirdTabPanel'
    ],
    style: {
      backgroundColor: _vm.mergeStyleOption.bgColor
    }
  }, [(_vm.type === 'third-group' && !_vm._isColmo) ? _c('div', {
    class: ['dof-third-panel'],
    style: {
      'background-color': _vm.mergeStyleOption.bgColor
    },
    attrs: {
      "accessible": true,
      "ariaLabel": _vm.text
    }
  }, [_c('div', {
    staticClass: ["btn-group-wrap"],
    style: _vm.wrapStyle
  }, _vm._l((_vm.tabTitles), function(text, index) {
    return _c('text', {
      key: index,
      class: [
        'btn-text',
        index == 0 && 'leftRadius',
        index == _vm.tabTitles.length - 1 && 'rightRadius',
        !_vm.disabled && _vm.pattern === 'text' && ("dof-text-highlight-" + _vm.type)
      ],
      style: [
        index < _vm.tabTitles.length - 1 ? _vm.verticalLineStyle : '',
        _vm.textStyle,
        index == _vm.tabCheckedIndex ? _vm.textBtnStyle(index) : ''
      ],
      attrs: {
        "dataIndex": index
      },
      on: {
        "click": function($event) {
          _vm.onTextClicked(index)
        }
      }
    }, [_vm._v(_vm._s(text))])
  }))]) : _vm._e(), (_vm.type === 'third-group' && _vm._isColmo) ? _c('dof-diamond-tab', {
    attrs: {
      "tabData": _vm.tabTitles,
      "bgColor": '#151617',
      "activeTextColor": 'rgb(230, 230, 230)',
      "touchColor": 'rgb(26, 26, 26)',
      "textFontSize": '28px',
      "active": _vm.tabCheckedIndex
    },
    on: {
      "tabActiveChange": _vm.tabActiveChange
    }
  }) : _vm._e(), (_vm.type === 'third') ? _c('scroller', {
    class: ['tab-title-list', _vm.tabTitles.length <= 5 && 'space-around-layout'],
    attrs: {
      "showScrollbar": false,
      "scrollDirection": "horizontal"
    }
  }, _vm._l((_vm.tabTitles), function(v, index) {
    return _c('div', {
      key: index,
      ref: 'dof-tab-title-' + index,
      refInFor: true,
      class: ['title-item', _vm.tabTitles.length > 5 && 'padding-layout-8'],
      on: {
        "click": function($event) {
          _vm.onClicked(index, _vm.tabTitles.length - 1)
        }
      }
    }, [_c('div', {
      staticClass: ["tab-text-wrapper", "thidrd-wrapper"],
      style: {
        backgroundColor: _vm.currentPage === index ?
          _vm.mergeStyleOption.activeBoxBgColor :
          (v.icon || v.activeIcon) && !_vm._isDiablo ?
          'transparent' :
          _vm.mergeStyleOption.boxBgColor,
        borderColor: _vm.currentPage === index && _vm.mergeStyleOption.activeBorderColor ?
          _vm.mergeStyleOption.activeBorderColor :
          _vm.mergeStyleOption.borderColor
      }
    }, [(v.icon || v.activeIcon) ? _c('image', {
      staticClass: ["avatar-icon"],
      attrs: {
        "src": _vm.currentPage === index ? v.activeIcon : v.icon
      }
    }) : _vm._e(), _c('text', {
      staticClass: ["tab-text", "third-text"],
      style: {
        fontWeight: _vm.currentPage === index && _vm.mergeStyleOption.isActiveTitleBold ? 'normal' : 'normal',
        color: _vm.currentPage === index ? _vm.mergeStyleOption.activeTitleColor : _vm.mergeStyleOption.titleColor
      }
    }, [_vm._v(_vm._s(v.title))])])])
  })) : _vm._e(), (_vm.type !== 'third' && _vm.type !== 'third-group') ? _c('scroller', {
    class: ['tab-title-list', _vm.tabTitles.length <= 5 && 'space-around-layout', _vm.isFlexStart && 'flex-start-layout'],
    attrs: {
      "showScrollbar": false,
      "scrollDirection": "horizontal"
    }
  }, _vm._l((_vm.tabTitles), function(v, index) {
    return _c('div', {
      key: index,
      ref: 'dof-tab-title-' + index,
      refInFor: true,
      class: ['title-item', _vm.tabTitles.length > 5 && 'padding-layout-32', _vm.type == 'primary' && 'title-item-primary', _vm.isFlexStart && _vm.tabTitles.length - 1 !== index && 'flex-start-item'],
      on: {
        "click": function($event) {
          _vm.onClicked(index, _vm.tabTitles.length - 1)
        }
      }
    }, [_c('div', {
      class: ['tab-text-wrapper', _vm.isSlot && 'minibar-inner']
    }, [_c('div', {
      staticClass: ["flexDirection"],
      class: [v.hasDotNum && 'dot-num-tip-right']
    }, [_c('text', {
      class: ['tab-text', 'dot-tab-text'],
      style: {
        fontSize: _vm.isFlexStart && _vm.currentPage === index ? '36px' : _vm.isFlexStart && _vm.currentPage !== index ? '28px' : _vm.type === 'primary' ? '32px' : '28px',
        fontWeight: _vm.currentPage === index && _vm.mergeStyleOption.isActiveTitleBold ? 'normal' : 'normal',
        color: _vm.currentPage === index ? _vm.mergeStyleOption.activeTitleColor : _vm.mergeStyleOption.titleColor
      }
    }, [_vm._v(_vm._s(v.title))]), (v.hasDotTip) ? _c('div', [_c('div', {
      staticClass: ["dot-tip"],
      style: {
        'background-color': v.badgeColor ? v.badgeColor : '#F56428'
      }
    })]) : (v.hasDotNum) ? _c('text', {
      staticClass: ["dot-num-tip-text"],
      style: {
        'background-color': v.badgeColor ? v.badgeColor : '#F56428'
      }
    }, [_vm._v(_vm._s(_vm.dotNum(v.hasDotNum, v.badgeMax)))]) : _vm._e()])]), (_vm.type !== 'third' && _vm.type !== 'third-group') ? _c('div', {
      class: [
        _vm.type == 'primary' ? 'border-bottom-line' : 'border-bottom-line-secondary',
        v.hasDotTip && 'dot-bottom-border',
        v.hasDotNum && 'dotNum-bottom-borderWidth'
      ],
      style: {
        backgroundColor: _vm.currentPage === index ? _vm.mergeStyleOption.activeBottomColor : 'transparent'
      }
    }) : _vm._e()])
  })) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-728a62c0!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-tab-page/index.vue
// module id = 632
// module chunks = 0 1